import { isProduction, ProductKey } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const bundlesThatRedirectToServiceCollection = [
    "jira-service-desk-jira-software-confluence",
    "confluence-jira-service-desk",
    "confluence-jira-service-management",
    "jira-service-desk-confluence",
    "jira-service-management-confluence",
    "jira-software-jira-service-management",
    "jira-service-management-jira-software",
    "jira-service-management-jira-software-confluence",
    "jira-software-jira-service-management-confluence"
];

export const bundlesThatRedirectToServiceCollectionInProdOnly = ["opsgenie"];

export const bundlesThatRedirectToTeamworkCollection = [
    "confluence-jira-software",
    "jira-software-confluence",
    "jira-software-confluence-compass"
];

// when signupRedirectMoreBundles gate is productionized, merge with bundlesThatRedirectToTeamworkCollection
export const moreBundlesThatRedirectToTwc = ["jira-core-confluence"];

export const bundlesThatRedirectToConfluence = ["fabric"];

// Redirection for product to supported Bundle
export const handleSignupRouteRedirects = ({
    product,
    bundle,
    isUpgradeEligible,
    edition
}: {
    product: string;
    bundle: string;
    isUpgradeEligible?: boolean;
    edition?: string;
    // eslint-disable-next-line complexity
}): boolean => {
    const townsquareRedirectionURL =
        "https://community.atlassian.com/t5/Atlas-Group-articles/Atlas-is-evolving/ba-p/2686154";
    const productParamRedirect = (): boolean => {
        const productBundleMap: { [key: string]: string } = {
            "loom": "loom",
            "com.atlassian.bitbucket": "bitbucket",
            "opsgenie": "opsgenie",
            "compass": "compass",
            "statuspage": "statuspage"
        };
        const bundleKey = productBundleMap[product];

        if (bundleKey && bundle !== bundleKey) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", bundleKey);
                currentUrl.searchParams.delete("product");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (product === "atlassian-whiteboard") {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("product", "confluence.ondemand");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (product === "townsquare") {
            if (typeof window.location.assign === "function") {
                window.location.assign(townsquareRedirectionURL);
            }
            return true;
        }
        return false;
    };
    if (product && productParamRedirect()) {
        return true;
    }
    const bundleParamRedirect = (): boolean => {
        const isJswRedirectBundle =
            bundle === "avocado" ||
            bundle === "jira-ops" ||
            bundle === "devops";
        const isBitbucketRedirectBundle =
            bundle === "jira-software-bitbucket" ||
            bundle === "bitbucket-jira-software";

        if (isJswRedirectBundle || isBitbucketRedirectBundle) {
            const redirectBundle = isJswRedirectBundle
                ? "jira-software"
                : "bitbucket";
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", redirectBundle);
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (bundlesThatRedirectToConfluence.includes(bundle)) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "confluence");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        const isTeamCentralBundle =
            bundle === "team-central" || bundle === "atlas";
        if (isTeamCentralBundle) {
            if (typeof window.location.assign === "function") {
                window.location.assign(townsquareRedirectionURL);
            }
            return true;
        }
        return false;
    };
    if (bundle && bundleParamRedirect()) {
        return true;
    }
    const collectionRedirection = (): boolean => {
        if (
            (product === ProductKey.JIRA_SERVICE_MANAGEMENT ||
                bundle === "jira-service-management" ||
                bundle === "jira-service-desk") &&
            (edition === "free" || isUpgradeEligible === false)
        ) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "service-collection");
                currentUrl.searchParams.set(
                    "primaryCollectionProduct",
                    ProductKey.JIRA_SERVICE_MANAGEMENT
                );
                currentUrl.searchParams.delete("product");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (collectionRedirection()) {
        return true;
    }
    const serviceCollectionBundleRedirection = (): boolean => {
        if (
            bundlesThatRedirectToServiceCollection.includes(bundle) ||
            (isProduction() &&
                bundlesThatRedirectToServiceCollectionInProdOnly.includes(
                    bundle
                ))
        ) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "service-collection");
                currentUrl.searchParams.set(
                    "primaryCollectionProduct",
                    ProductKey.JIRA_SERVICE_MANAGEMENT
                );
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (serviceCollectionBundleRedirection()) {
        return true;
    }
    const teamworkCollectionBundleRedirection = (): boolean => {
        if (bundlesThatRedirectToTeamworkCollection.includes(bundle)) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "teamwork-collection");
                currentUrl.searchParams.delete("product");
                currentUrl.searchParams.delete("developer");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (
            checkFeatureFlagGate(featureFlags.signupRedirectMoreBundles) &&
            moreBundlesThatRedirectToTwc.includes(bundle)
        ) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "teamwork-collection");
                currentUrl.searchParams.delete("product");
                currentUrl.searchParams.delete("developer");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (teamworkCollectionBundleRedirection()) {
        return true;
    }

    return false;
};
